<script>
	import registrationTypes from "../config/registrationTypes";

	import ClaimantSomeoneElse from "./ClaimantSomeoneElse.svelte";
	import ClaimantDeceasedEstate from "./ClaimantDeceasedEstate.svelte";

	export let disabled = null;
	export let registrationType;
	export let claimantDetails;
	export let claimants;
	export let contactFirstName;
	export let contactSurname;
</script>

{#if registrationType == registrationTypes.types.SomeoneElse.value}
	<ClaimantSomeoneElse {disabled} bind:claimantDetails bind:claimants />
{:else}
	<!-- Currently deceased estate not required for this CA. Keeping code in incase its requiured later down the line -->
	<ClaimantDeceasedEstate {disabled} bind:claimantDetails bind:claimants {contactFirstName} {contactSurname} />
{/if}
